import React, { useEffect, useState } from "react";
import UserHeader from "./UserHeader";
import UserFooter from "./UserFooter";
import ProfileContainer from "./ProfileContainer";
import MatchProfileContainer from "./MatchProfileContainer";
import { getAllDashboardData } from "../../asiosConfig";
import { toast } from "react-toastify";
import { Activity } from "./Profile/Activity";
import { Search } from "./Profile/Search";
import { Messenger } from "./Profile/Messenger";
import { Upgrade } from "./Profile/Upgrade";
import { Filter } from "./Profile/Filter";
import { SearchResult } from "./Profile/SearchResult";
import { ProfileRouteContainer } from "./Profile/ProfileRouteContainer";

function Dashboard() {
  const [profileData, setProfileData] = useState(null);
  console.log("profileData", profileData);
  const [matches, setMatches] = useState([]);
  const [activeSection, setActiveSection] = useState("matches");
  const [interesetAccept, setInterestAccept] = useState([]);
  const [interestReceived, setInterestReceived] = useState([]);
  const [shortListed, setShortListed] = useState([]);
  const [onlineMatches, setOnlineMatches] = useState([]);
  const [recentJoined, setRecentJoined] = useState([]);
  const [filters, setFilters] = useState({});

  const [searchResult, setSearchResult] = useState({});
  const [matchesType, setMatchesType] = useState("my_matches");
  console.log("matchesType", matchesType);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await getAllDashboardData();
        if (response.status === 200 || response.status === 201) {
          localStorage.setItem(
            "username",
            response.data.DASHBOARD.user_info.username,
          );
          setProfileData(response.data.DASHBOARD.user_info);
          setMatches(response.data.DASHBOARD.myMatches.myMatches_profiles);
          setInterestAccept(response.data.DASHBOARD.interestAccepted);
          setInterestReceived(response.data.DASHBOARD.interestReceived);
          setShortListed(response.data.DASHBOARD.myBookMark);
          setOnlineMatches(
            response.data.DASHBOARD.myOnlineMatches.myOnlineMatches_profiles,
          );
          setRecentJoined(
            response.data.DASHBOARD.recentlyJoined.recentlyJoined_profiles,
          );
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        const status = error.response?.status;

        // 🔑 Do NOT show error for auth-related or temporary failures
        if (status !== 401 && status !== 403) {
          console.warn("Dashboard fetch failed:", error);
          // ❌ NO toast here
        }
      }
    };
    fetchDashboard();
  }, []);
  if (!profileData || matches.length === 0) return <p>Loading...</p>;

  const getTitle = () => {
    switch (matchesType) {
      case "my_interest_accepted":
        return "All Profiles Interest Accepted";
      case "interest_received":
        return "All Profiles Received Interest";
      case "interest_sent":
        return "All Profiles Sent Interest";
      case "my_bookmarks":
        return "All Bookmarked Profiles";
      default:
        return "All Profiles";
    }
  };
  const handleFilterSubmit = (filterData) => {
    setFilters(filterData);
    setActiveSection("matches");
  };
  const handleSearchData = (searchData) => {
    setSearchResult(searchData);
    setActiveSection("searchResult");
  };
  const handleViewAllClick = (title, matchesType) => {
    setMatchesType(matchesType);
    setActiveSection("matches");
  };
  const renderSection = () => {
    switch (activeSection) {
      case "matches":
        return (
          <MatchProfileContainer
            matchesType={matchesType}
            setActiveSection={setActiveSection}
            filters={filters}
            title={getTitle()}
          />
        );
      case "activity":
        return (
          <Activity
            onlineMatches={onlineMatches}
            interesetAccept={interesetAccept}
            interestReceived={interestReceived}
            shortListed={shortListed}
            recentJoined={recentJoined}
            onViewAllClick={handleViewAllClick}
          />
        );
      case "search":
        return <Search onSubmit={handleSearchData} />;
      case "messenger":
        return <Messenger />;
      case "upgrade":
        return <Upgrade />;
      case "filter":
        return <Filter onSubmit={handleFilterSubmit} />;
      case "searchResult":
        return <SearchResult searchResult={searchResult} />;
      default:
        return (
          <MatchProfileContainer
            matchesType={matchesType}
            setActiveSection={setActiveSection}
            filters={filters}
            title={getTitle()}
          />
        );
    }
  };

  return (
    <div>
      <UserHeader />
      <section className="middelBlock">
        <div className="container">
          <div className="row">
            <ProfileContainer
              profileData={profileData}
              setActiveSection={setActiveSection}
            />
            {/* <ProfileRouteContainer profileData={profileData}/> */}
            {/* <MatchProfileContainer matches={matches}/> */}
            {renderSection()}
          </div>
        </div>
      </section>
      {/* <UserFooter /> */}
    </div>
  );
}

export default Dashboard;
